import { getAmkaRegistryInfo } from "src/apis/controllers/applications";

export const getByAmkaAfm = async (amka, afm) => {
  if (amka && afm) {
    const res = await getAmkaRegistryInfo({ amka, afm });
    return res;
  }
  return { status: "empty" };
};
